export interface ArtifactTitleLike {
  kind?: string | null;
  summary?: string | null;
  labels?: Record<string, string | undefined> | null;
}

export type ArtifactSummaryParts =
  | {
      type: 'command';
      command: string;
    }
  | {
      type: 'text';
      text: string;
    };

const isCommandOutputKind = (kind?: string | null): boolean => String(kind ?? '').trim().toLowerCase() === 'commandoutput';

const normalizeArtifactCommand = (command?: string | null): string | null => {
  const trimmed = command?.trim();
  if (!trimmed) {
    return null;
  }
  if (/^[-:|]+$/.test(trimmed)) {
    return null;
  }
  return trimmed;
};

const extractCommandFromSummary = (summary?: string | null): string | null => {
  const trimmed = summary?.trim();
  if (!trimmed) {
    return null;
  }
  const match = trimmed.match(/^output for\s+(.+)$/i);
  if (!match) {
    return null;
  }
  return normalizeArtifactCommand(match[1]);
};

export const isPlaceholderArtifactSummary = (summary?: string | null): boolean => {
  const trimmed = summary?.trim();
  if (!trimmed) {
    return false;
  }
  return /^output for(?:\s*-\s*)?$/i.test(trimmed);
};

const normalizeArtifactSummary = (summary?: string | null): string | null => {
  const trimmed = summary?.trim();
  if (!trimmed) {
    return null;
  }
  if (isPlaceholderArtifactSummary(trimmed)) {
    return null;
  }
  return trimmed;
};

export const resolveArtifactSummaryParts = (artifact: ArtifactTitleLike): ArtifactSummaryParts => {
  if (isCommandOutputKind(artifact.kind)) {
    const command = normalizeArtifactCommand(artifact.labels?.command) ?? extractCommandFromSummary(artifact.summary);
    if (command) {
      return {
        type: 'command',
        command
      };
    }

    const summary = normalizeArtifactSummary(artifact.summary);
    if (summary) {
      return {
        type: 'text',
        text: summary
      };
    }

    return {
      type: 'text',
      text: 'Command output'
    };
  }

  const summary = artifact.summary?.trim();
  if (summary) {
    return {
      type: 'text',
      text: summary
    };
  }

  return {
    type: 'text',
    text: 'Artifact'
  };
};
